import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import history from '../../helpers/history';
import { Layout, PageHeader, Table, Select, AutoComplete, Button, Input, List, Divider, Spin, Icon, Modal, message, Row, Col, Upload, Radio } from 'antd';

import TradeResult from './TradeResult';

import emitter from '../Evt.js';
import { buffers } from 'redux-saga';

var moment_timezone = require('moment-timezone');

const { Sider, Content } = Layout;
const Option = Select.Option;
const Confirm = Modal.confirm;

var languageMessages = window.appLocale.messages;

function strReplace(source, jsonObjcet) {
    for (var v in jsonObjcet) {
        source = source.replace(v, jsonObjcet[v]);
    }
    return source;
}

const selRateOfReturn = [
    { 'id': '0', 'name': languageMessages['all'] },
    { 'id': '1', 'name': '0~10%' },
    { 'id': '2', 'name': '11%~20%' },
    { 'id': '3', 'name': '21%~30%' },
    { 'id': '4', 'name': '31%~40%' },
    { 'id': '5', 'name': '41%~50%' },
    { 'id': '6', 'name': strReplace(languageMessages['theAbove'], { '{num}': '50%' }) },
    { 'id': '7', 'name': '-10%~0' },
    { 'id': '8', 'name': '-20%~-11%' },
    { 'id': '9', 'name': '-30%~-21%' },
    { 'id': '10', 'name': '-40%~-31%' },
    { 'id': '11', 'name': '-50%~-41%' },
    { 'id': '12', 'name': strReplace(languageMessages['theFollowing'], { '{num}': '-50%' }) }
];

const strCategory = [
    languageMessages['generalStrategy'],
    languageMessages['backtestGrid'],
    languageMessages['AIincrease'],
    languageMessages['optimalGrid'],
    languageMessages['strategyExcavate'],
    languageMessages['AIincrease'] + '-' + languageMessages['optimizationGrid'],
    languageMessages['optimalGrid'] + '-' + languageMessages['optimizationGrid'],
    languageMessages['AIincrease'] + '-' + languageMessages['rollingBacktest'],
    languageMessages['optimalGrid'] + '-' + languageMessages['rollingBacktest'],
    languageMessages['rollingStrategy']
];

function guid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

class SimulationPage extends Component {
    constructor(props) {
        super(props);

        window.webType === 'US' ? moment_timezone.tz.setDefault("America/New_York") : moment_timezone.tz.setDefault("Asia/Shanghai");

        this.user = {};
        this.state = {
            keywords: '',
            symbolItems: [],

            symbolCode: '',
            symbolName: '',

            maxRateOfReturn: '0',

            currSelStock: '',

            strategyData: [],

            dataSource: [],

            rowId: -1,
            type: 1,

            tradeResult: {},
            statisticsResult: [],

            strategyTradeResult: [],

            selectedRowKeys: [],
            strategyIds: [],

            spinLoadding: true,

            spinModalLoadding: false,

            modalStrategyId: '',
            modalSymbolCode: '',
            //modalSymbolName: '',
            //modalStrategyName: '',
            modalStrategyType: '',
            initCapital: 0,
            capital: 0,
            gridCnt: 0,
            category: 0,
            modalVisible: false,

            basePosition: 0,
            share: 0,

            broker: window.webType === 'US' ? 'TD' : 'Quancept',
            accountType: '0',

            fileList: [],

        };
    }

    componentDidMount() {
        emitter.addListener('initPage', this.init);

        emitter.addListener("callSendTradeError", this.callSendTradeError);
        emitter.addListener('callDeployStrategy', this.callDeployStrategy);
    }

    componentWillMount() {
        this.init();
    }

    componentWillUnmount() {
        emitter.removeListener('initPage', this.init);
        emitter.removeListener('callSendTradeError', this.callSendTradeError);
        emitter.removeListener('callDeployStrategy', this.callDeployStrategy);
    }

    callSendTradeError = (status) => {
        message.error(languageMessages['deployStrategySubmitFail'] + ', Error:' + status);

        this.setState({ spinModalLoadding: false, modalVisible: false });
    }

    callDeployStrategy = (status, deployStrategy) => {
        this.setState({ spinModalLoadding: false, modalVisible: false }, () => {
            if (status == 0) {
                //emitter.emit('callJump', 'realtime');
                //history.push("/re");

                var content = <span>{languageMessages['checkLiveTradeStatus']} <a href="javascript:;" onClick={this.jumpRealtime}>{languageMessages['checkLiveTradeStatusUrl']}</a></span>;
                this.timerModal(languageMessages['newRealTradeSucc'], content);
            } else {
                message.error(languageMessages['deployStrategyFail'] + ', Error:' + status);
            }
        });
    }

    timerModal(title, content) {
        const modal = Modal.success({
            title: title,
            content: content,
            onOk() { },
        });

        /**
        var secondsToGo = 5;
        setTimeout(() => {
            modal.destroy();
        }, secondsToGo * 1000);
        */
    }

    jumpRealtime = e => {
        e.preventDefault();

        Modal.destroyAll();

        emitter.emit('callJump', 'realtime');
        history.push("/re");
    }

    init = () => {
        var { symbolCode, maxRateOfReturn, type } = this.state;

        this.user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};

        /**
        var maxRateOfReturns = selRateOfReturn.filter(function (v) { return maxRateOfReturn == v.id });
        if (maxRateOfReturns.length > 0) {
            if (maxRateOfReturns[0].id == '0') {
                maxRateOfReturn = '';
            } else {
                maxRateOfReturn = maxRateOfReturns[0].name;
            }
        } else {
            maxRateOfReturn = '';
        }
        */

        var userId = this.user.username === undefined ? '' : this.user.username;
        this.props.dispatch({ type: "action_get_trade_result", payload: { t: type, u: userId, s: symbolCode, r: maxRateOfReturn } });
    }

    keepDecimals(value, sign) {
        value = value == null ? '' : value;
        if (value !== '') {
            value = value.replace(/([0-9]+.[0-9]{2})[0-9]*/, "$1");
            value += sign;
        }

        return value;
    }

    setTradeResult(tmpDataSource) {
        var rowId = -1;
        var statisticsResult = [];
        var dataSource = [];
        if (tmpDataSource.length > 0) {
            for (var item in tmpDataSource) {
                if (rowId === -1) {
                    rowId = tmpDataSource[item].i;

                    if (tmpDataSource[item].tradeDetails != null) {
                        statisticsResult = tmpDataSource[item].tradeDetails;
                    }
                }

                var sequence = parseInt(item) + 1;

                var grandTotalRateOfReturn = 1;
                var annualizedRateOfReturn = 2;

                dataSource.push({
                    key: tmpDataSource[item].i,
                    sequence: sequence,
                    symbolCode: tmpDataSource[item].s,

                    tbLogin: tmpDataSource[item].tb,

                    grandTotalRateOfReturn: grandTotalRateOfReturn,
                    annualizedRateOfReturn: annualizedRateOfReturn,

                    category: tmpDataSource[item].cg,
                    initCapital: tmpDataSource[item].ct,
                    capital: tmpDataSource[item].ct,
                    gridCnt: tmpDataSource[item].gridCnt,
                    tradingStraregy: tmpDataSource[item].sn.replace('strategy', languageMessages['gridStrategy']),
                    dayTradeOnly: tmpDataSource[item].dt,
                    startTime: tmpDataSource[item].fd,
                    endTime: tmpDataSource[item].ed,
                    status: tmpDataSource[item].status
                });
            }
        }

        return { dataSource, rowId, statisticsResult };
    }

    componentWillReceiveProps(props) {
        var { status, symbolItems, tradeResult, symbols, basePosition, share, uri, state } = props;

        switch (status) {
            case 'get_symbol_items_success':
                if (symbolItems !== undefined && symbolItems.length > 0) {
                    this.setState({ symbolItems });
                } else {
                    if (this.state.keywords !== '') {
                        this.setState({ symbolItems: [{ symbol: '"' + this.state.keywords + '"' + languageMessages['no.matches.found'], symbolName: '' }] });
                    } else {
                        this.setState({
                            symbolItems: []
                        });
                    }
                }
                break;
            case 'get_trade_result_success':
                var currSelStock = '';
                var strategyData = [];
                for (var item in symbols) {
                    if (currSelStock === '') currSelStock = symbols[item].sc;

                    if (tradeResult.hasOwnProperty(currSelStock)) {
                        strategyData.push({
                            'id': symbols[item].i, 'stockCode': symbols[item].sc, 'stockName': symbols[item].sn
                        });
                    } else {
                        currSelStock = '';
                    }
                }

                var strategyTradeResult = [];
                if (currSelStock !== '') {
                    strategyTradeResult = tradeResult[currSelStock];
                }

                var { dataSource, rowId, statisticsResult } = this.setTradeResult(strategyTradeResult);
                this.setState({ strategyData, currSelStock, tradeResult, strategyTradeResult, spinLoadding: false, dataSource, rowId, statisticsResult });
                break;
            case 'get_trade_result_fail':
                this.setState({ spinLoadding: false });
                break;
            case 'get_get_trade_result_search_success':
                var currSelStock = this.state.currSelStock;
                var tmpTradeResult = this.state.tradeResult;

                var strategyTradeResult = [];
                if (currSelStock !== '') {
                    strategyTradeResult = tradeResult[currSelStock];
                    tmpTradeResult[currSelStock] = strategyTradeResult;
                }
                
                var { dataSource, rowId, statisticsResult } = this.setTradeResult(strategyTradeResult);
                this.setState({ tradeResult: tmpTradeResult, strategyTradeResult, spinLoadding: false, dataSource, rowId, statisticsResult });
                break;
            case 'get_trade_result_search_fail':
                this.setState({ spinLoadding: false });
                break;
            case 'get_remove_trade_success':
                var currSelStock = this.state.currSelStock;
                var strategyData = this.state.strategyData;
                var tmpSymbols = symbols.filter(function (s) { return currSelStock == s.sc });
                if (tmpSymbols.length === 0) {
                    currSelStock = '';
                    strategyData = [];
                    for (var item in symbols) {
                        if (currSelStock === '') currSelStock = symbols[item].sc;

                        strategyData.push({
                            'id': symbols[item].i, 'stockCode': symbols[item].sc, 'stockName': symbols[item].sn
                        });
                    }
                }

                var strategyTradeResult = [];
                if (currSelStock !== '') {
                    strategyTradeResult = tradeResult[currSelStock];
                }

                var { dataSource, rowId, statisticsResult } = this.setTradeResult(strategyTradeResult);
                this.setState({ strategyData, currSelStock, tradeResult, strategyTradeResult, spinLoadding: false, dataSource, selectedRowKeys: [], rowId, statisticsResult });

                var sequenceIds = this.state.strategyIds.join(',');
                message.success(strReplace(languageMessages['remove.trade.success'], { '{num}': sequenceIds }));

                /**
                let { dataSource, strategyTradeResult, rowId, statisticsResult } = this.state;

                var tmpValue = tradeIds.split(',');

                if (tmpValue.length > 0) {
                    var tmpRowKeys = tmpValue.filter(function (e) { return e === rowId.toString(); });
                    if (tmpRowKeys.length > 0) {
                        rowId = -1;
                        statisticsResult = [];
                        var tmpData = strategyTradeResult.filter(function (e) { return tmpValue.indexOf(e.i.toString()) === -1 });
                        if (tmpData.length > 0) {
                            rowId = tmpData[0].i;
                            if (tmpData[0].statistics != null) {
                                statisticsResult = tmpData[0].statistics;
                            }
                        }
                    }

                    dataSource = dataSource.filter(function (v) { return tmpValue.indexOf(v.key.toString()) === -1 });

                    message.success(languageMessages['remove.trade.success']);
                }
                this.setState({ spinLoadding: false, dataSource, selectedRowKeys: [], rowId, statisticsResult });
                */
                break;
            case 'get_remove_trade_fail':
                this.setState({ spinLoadding: false });
                break;
            case 'get_base_position_success':
                this.setState({
                    modalTitle: languageMessages['newRealTimeTrade'],
                    modalVisible: true,
                    basePosition,
                    share,
                    spinLoadding: false
                });

                break;
            case 'get_base_position_fail':
                this.setState({ spinLoadding: false });
                break;
            case 'get_auth_success':
                const w = window.open('about:blank');
                w.location.href = uri;

                break;
            case 'get_auth_failed':
                if (state == 3) message.info(languageMessages['Authentication is normal']);
                else message.info(languageMessages['Failed to get auth url']);
                break;
            default:
                break;
        }
    }

    onChangeSymbol = (symbolCode) => {
        this.setState({ symbolCode });
    }

    // 选择标的
    onSelectSymbol = value => {
        if (value !== '') {
            if (value.search(languageMessages['no.matches.found']) === -1) {
                //languageMessages['no.matches.found']

                //var symbolItems = JSON.parse(sessionStorage.getItem("SymbolItemsCache") || '[]') || [];
                //var tmpDataCode = symbolItems.filter(function (e) { return e.stockCode.toLowerCase() === value.toLowerCase(); });
                var tmpDataCode = this.state.symbolItems.filter(function (e) { return e.symbol.toLowerCase() === value.toLowerCase(); });

                if (tmpDataCode.length > 0) {
                    var symbolCode = tmpDataCode[0].symbol;
                    var symbolName = tmpDataCode[0].symbolName;

                    this.setState({ symbolCode, symbolName }, () => {
                        //this.setBaseInfo();
                        /**
                        var user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
                        if (user.username === undefined) {
                            this.props.dispatch({ type: "action_non_user" });
                        } else {
                            this.props.dispatch({ type: "action_get_stock_tick", payload: { UserId: user.username, SymbolList: symbolCode } });
                        }
                        */
                    });
                }
            }
        }
    }

    onFocusSymbol = () => {
        // defaylt symbol items
    }

    onBlurSymbol = value => {
        if (value !== '') {
            var tmpDataCode = this.state.symbolItems.filter(function (e) { return e.symbol.toLowerCase() === value.toLowerCase(); });
            if (tmpDataCode.length === 0) {
                tmpDataCode = this.state.symbolItems.filter(function (e) { return e.symbol.substring(2, e.symbol.length) === value; });
            }

            if (tmpDataCode.length === 1) {
                var symbolCode = tmpDataCode[0].symbol;
                var symbolName = tmpDataCode[0].symbolName;

                this.setState({ symbolCode, symbolName });
            } else {
                this.setState({
                    symbolItems: [],
                    symbolCode: '',
                    symbolName: ''
                });
            }
        } else {
            this.setState({
                symbolItems: [],
                symbolCode: '',
                symbolName: ''
            });
        }
    }

    // 匹配标的
    handleSearch = value => {
        this.setState({ keywords: value }, () => {
            /**
            if (this.user.username === undefined) {
                this.props.dispatch({ type: "action_non_user" });
            } else {
                this.props.dispatch({ type: "action_get_symbol_items", payload: { UserId: this.user.username, keywords: value } });
            }
            */
            this.props.dispatch({ type: "action_get_symbol_items", payload: { UserId: this.user.username, keywords: value } });
        });
    };

    handleIncomesChange = value => {
        this.setState({ maxRateOfReturn: value.key });
    }

    handleSelStock = symbol => {
        if (symbol !== '') {
            var { tradeResult, currSelStock, symbolCode, maxRateOfReturn, type } = this.state;
            
            if (symbolCode == symbol) return;
            if (currSelStock == symbol) return;
            /**
            if (tradeResult.hasOwnProperty(symbol)) {
                var strategyTradeResult = tradeResult[symbol];

                var { dataSource, rowId, statisticsResult } = this.setTradeResult(strategyTradeResult);
                this.setState({ currSelStock: symbol, strategyTradeResult, dataSource, rowId, statisticsResult });
            } else {
            */
            this.setState({ currSelStock: symbol, spinLoadding: true }, () => {
                    var userId = this.user.username === undefined ? '' : this.user.username;
                    this.props.dispatch({ type: "action_get_trade_result_search", payload: { t: type, u: userId, s: symbol, r: maxRateOfReturn } });
                });
            //}
        }
    }

    clearFilter = () => {
        this.setState({ symbolCode: '', symbolName: '', maxRateOfReturn: '0', spinLoadding: true }, () => {
            var userId = this.user.username === undefined ? '' : this.user.username;
            this.props.dispatch({ type: "action_get_trade_result", payload: { t: this.state.type, u: userId, s: '', r: '0' } });
        });
    }

    handleSearchStockTrade = () => {
        var { symbolCode, maxRateOfReturn, type } = this.state;

        /**
        var maxRateOfReturns = selRateOfReturn.filter(function (v) { return maxRateOfReturn == v.id });
        if (maxRateOfReturns.length > 0) {
            if (maxRateOfReturns[0].id == '0') {
                maxRateOfReturn = '';
            } else {
                maxRateOfReturn = maxRateOfReturns[0].name;
            }
        } else {
            maxRateOfReturn = '';
        }
        */

        this.setState({ spinLoadding: true }, () => {
            var userId = this.user.username === undefined ? '' : this.user.username;
            this.props.dispatch({ type: "action_get_trade_result", payload: { t: type, u: userId, s: symbolCode, r: maxRateOfReturn } });
        });
    }

    onRemove = () => {
        var { selectedRowKeys, currSelStock, symbolCode, type } = this.state;

        if (selectedRowKeys.length > 0) {
            if (this.user.username === undefined) {
                this.props.dispatch({ type: "action_non_user" });
            } else {
                var tradeIds = selectedRowKeys.join(',');

                var _this = this;
                Confirm({
                    title: languageMessages['want.delete.trade'],
                    content: '',
                    okText: languageMessages['yes'],
                    okType: 'danger',
                    cancelText: languageMessages['no'],
                    onOk() {
                        _this.setState({ spinLoadding: true }, () => {
                            _this.props.dispatch({ type: "action_remove_trade", payload: { t: type, u: _this.user.username, s: currSelStock, sc: symbolCode, ts: tradeIds } });
                        });
                    },
                    onCancel() { },
                });
            }
        }
    };

    OnSelectShowChart = (record) => {
        return {
            onClick: () => {
                const { strategyTradeResult, selectedRowKeys } = this.state;

                var tmpData = strategyTradeResult.filter(function (e) { return e.i === record.key; });
                if (tmpData.length > 0) {
                    var statisticsResult = [];
                    if (tmpData[0].tradeDetails != null) {
                        statisticsResult = tmpData[0].tradeDetails;
                    }
                    /**
                    if (selectedRowKeys.indexOf(record.key) >= 0) {
                        selectedRowKeys.splice(selectedRowKeys.indexOf(record.key), 1);
                    } else {
                        selectedRowKeys.push(record.key);
                    }
                    */

                    this.setState({ rowId: record.key, statisticsResult, selectedRowKeys });
                }
            }
        }
    }

    setRowClassName = (record) => {
        return record.key.toString() === this.state.rowId.toString() ? 'common-table-row' : '';
    }

    onSelectChange = selectedRowKeys => {
        let strategyIds = [];
        for (var k in selectedRowKeys) {
            let data = this.state.dataSource.filter(function (e) { return e.key === selectedRowKeys[k]; });
            if (data.length > 0) {
                strategyIds.push(data[0].sequence);
            }
        }

        this.setState({ selectedRowKeys, strategyIds });
    };

    handleStrategy = (value) => {
        this.setState({
            spinLoadding: true,
            modalStrategyId: value.key,
            modalSymbolCode: value.symbolCode,
            modalStrategyType: value.dayTradeOnly,
            initCapital: value.capital,
            capital: value.capital,
            gridCnt: value.gridCnt,
            category: value.category
        }, () => {
            var userId = this.user.username === undefined ? '' : this.user.username;

            this.props.dispatch({ type: "action_get_base_position", payload: { u: userId, cg: value.category, s: value.symbolCode, g: value.gridCnt, c: 0 } });
        });
    }

    onSelAccountType = (e) => {
        this.setState({ accountType: e.target.value });
    }

    handleBrokerChange = (value) => {
        let broker = value.key;

        this.setState({ broker });
    }

    buildBindBroker = e => {
        var user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
        if (user.username === undefined) {
            this.setState({ spinLoadding: false }, () => {
                this.props.dispatch({ type: "action_non_user" });
            });
        } else {
            this.props.dispatch({ type: "action_get_auth", payload: { u: user.username } });
        }
    }

    renderModalContent() {
        return window.webType === 'US' ? this.renderModalContentForUs() : this.renderModalContentForCn();
    }

    handleChangeCapital = e => {
        var capital = e.target.value;

        this.setState({
            capital: capital
        }, () => {
            var userId = this.user.username === undefined ? '' : this.user.username;

            this.props.dispatch({ type: "action_get_base_position", payload: { u: userId, cg: this.state.category, s: this.state.modalSymbolCode, g: this.state.gridCnt, c: capital == '' ? 0 : capital } });
        });
    }

    handleBlurCapital = e => {
        e.preventDefault();

        var capital = e.target.value;

        this.setState({
            capital: capital
        }, () => {
            var userId = this.user.username === undefined ? '' : this.user.username;

            this.props.dispatch({ type: "action_get_base_position", payload: { u: userId, cg: this.state.category, s: this.state.modalSymbolCode, g: this.state.gridCnt, c: capital == '' ? 0 : capital } });
        });
    }

    renderModalContentForCn() {
        const brokerItems = [];
        brokerItems.push({ 'id': 'Quancept', 'name': '华鑫证券' });

        return <div>
            <Row>
                <Col className="common-gutter-row" span={6}>{languageMessages['chooseBroker']}：</Col>
                <Col span={16}>
                    <Select labelInValue size='small' value={{ key: this.state.broker }} style={{ width: '120px' }} onChange={this.handleBrokerChange} dropdownClassName="common-dropdownClassName">
                        {
                            brokerItems.map(item => (
                                <Option key={item.id}>{item.name}</Option>
                            ))
                        }
                    </Select>
                </Col>
            </Row>
            <Row>
                <Col className="common-gutter-row" span={6}>{languageMessages['accountType']}：</Col>
                <Col className="common-gutter-row" span={16}>
                    <div>
                        <Radio.Group size='small' value={this.state.accountType} onChange={this.onSelAccountType} buttonStyle="solid" style={{ marginBottom: '10px' }}>
                            <Radio.Button value="0">{languageMessages['cashAccount']}</Radio.Button>
                            <Radio.Button value="1">{languageMessages['financingAccount']}</Radio.Button>
                        </Radio.Group>
                    </div>
                    <div>
                        {languageMessages['buyingPowerRequried']} <span style={{ marginLeft: 10 }}>{this.state.initCapital}</span>
                    </div>
                    <div>
                        {languageMessages['Buying power to allocate']}
                        <span style={{ marginLeft: 10 }}>
                            <Input type="text" size='small' style={{ width: 120 }} value={this.state.capital} onChange={this.handleChangeCapital} onBlur={this.handleBlurCapital} placeholder='' data-value='capital' />
                        </span>
                    </div>
                    <div style={{ display: this.state.accountType == '0' ? '' : 'none' }}>
                        {languageMessages['minimumPositionRequired']}
                        <span style={{ marginLeft: 10 }}>{this.state.basePosition}</span>
                    </div>
                </Col>
            </Row>
            
        </div>
    }

    renderModalContentForUs() {
        const brokerItems = [];
        brokerItems.push({ 'id': 'TD', 'name': 'TdAmeritrade' }, { 'id': 'IB', 'name': 'IB' });

        return <div>
            <Row>
                <Col className="common-gutter-row" span={6}>{languageMessages['chooseBroker']}：</Col>
                <Col span={16}>
                    <Select labelInValue size='small' value={{ key: this.state.broker }} style={{ width: '120px' }} onChange={this.handleBrokerChange} dropdownClassName="common-dropdownClassName">
                        {
                            brokerItems.map(item => (
                                <Option key={item.id}>{item.name}</Option>
                            ))
                        }
                    </Select>
                </Col>
            </Row>
            <Row>
                <Col className="common-gutter-row" span={6}>{languageMessages['accountType']}：</Col>
                <Col className="common-gutter-row" span={16}>
                    <div>
                        <Radio.Group size='small' value={this.state.accountType} onChange={this.onSelAccountType} buttonStyle="solid" style={{ marginBottom: '10px' }}>
                            <Radio.Button value="0">{languageMessages['cashAccount']}</Radio.Button>
                            <Radio.Button value="1">{languageMessages['financingAccount']}</Radio.Button>
                        </Radio.Group>
                    </div>
                    <div>
                        {languageMessages['buyingPowerRequried']} <span style={{ marginLeft: 10 }}>{this.state.initCapital}</span>
                    </div>
                    <div>
                        {languageMessages['Buying power to allocate']}
                        <span style={{ marginLeft: 10 }}>
                            <Input type="text" size='small' style={{ width: 120 }} value={this.state.capital} onChange={this.handleChangeCapital} onBlur={this.handleBlurCapital} placeholder='' data-value='capital' />
                        </span>
                    </div>
                    <div style={{ display: this.state.accountType == '0' ? '' : 'none' }}>
                        {languageMessages['minimumPositionRequired']} <span style={{ marginLeft: 10 }}>{this.state.basePosition}</span>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col className="common-gutter-row" span={6}>{languageMessages['requiredSteps']}：</Col>
                <Col className="common-gutter-row" span={16}></Col>
            </Row>
            <Row>
                <Col className="common-gutter-row" span={24}>
                    <div style={{ display: this.state.broker == 'TD' ? '' : 'none' }}><Button size='small' onClick={this.buildBindBroker}>{languageMessages['login td account']}</Button></div>
                    <div style={{ display: this.state.broker == 'IB' ? '' : 'none' }}>
                        <div>{languageMessages['tradeLiveInfo01']}</div>
                        <div>{languageMessages['tradeLiveInfo02']}</div>
                        <div>
                            <Upload name='file' action="#"
                                beforeUpload={this.beforeUpload}
                                onChange={this.handleUploadChange}
                                fileList={this.state.fileList}>
                                <Button size='small'><Icon type="upload" /> {languageMessages['downloadQuanceptAgent']} </Button>
                            </Upload>
                        </div>
                        <div>{languageMessages['tradeLiveInfo03']}</div>
                    </div>
                </Col>
            </Row>
        </div>
    }

    beforeUpload = (file) => {
        if (this.user.username === undefined) {
            this.props.dispatch({ type: "action_non_user" });
            return false;
        } else {
            return true;
        }
    }

    handleUploadChange = (info) => {
        if (this.user.username === undefined) {
            this.props.dispatch({ type: "action_non_user" });
        } else {
            let fileList = info.fileList;

            if (info.file.status !== undefined) {
                this.setState({ fileList });
            }

            if (info.file.status === 'done') {
                //
            } else if (info.file.status === 'error') {
                this.setState({ fileList: [] });
            }
        }
    }

    handleOk = e => {
        var user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
        if (user.username === undefined) {
            this.props.dispatch({ type: "action_non_user" });
        } else {
            if (this.state.initCapital > this.state.capital) {
                message.info(languageMessages['Buying power to allocate tips']);
            } else {
                let { modalStrategyId, modalSymbolCode, modalStrategyType, capital, category, broker } = this.state;

                this.setState({ spinModalLoadding: true }, () => {
                    this.props.dispatch({
                        type: "action_send_hub_message", payload: {
                            service: 'SendTrade',
                            userId: user.username,
                            msg: {
                                Type: 'deployStrategy',
                                TradeType: 0,
                                BacktestId: '0',
                                StrategyId: modalStrategyId,
                                SymbolCode: modalSymbolCode,
                                Category: category,
                                Capital: capital,
                                DayTradeOnly: modalStrategyType,
                                ExecutionPlatform: broker,
                                ReqId: guid()
                            }
                        }
                    });
                });
            }
        }
    }

    handleCancel = e => {
        this.setState({ modalVisible: false, spinModalLoadding: false });
    }

    renderStockTrade(strategyData) {
        if (strategyData.length > 0) {
            return <List size={"small"}
                dataSource={strategyData}
                renderItem={item => (
                    <List.Item key={item.id} onClick={() => this.handleSelStock(item.stockCode)} className={this.state.currSelStock == item.stockCode ? 'checked' : ''}>
                        <List.Item.Meta
                            title={(<span style={{ fontWeight: '100' }}>{item.stockName}</span>)}
                            description={(<b>{item.stockCode}</b>)}
                        />
                    </List.Item>
                )}
            />
        } else {
            return <div style={{ textAlign: 'center', padding: '20px 0', color: 'rgba(100, 100, 100, 0.75' }}>{languageMessages['not']}</div>
        }
    }

    render() {
        var { strategyData, symbolItems, symbolCode, dataSource, selectedRowKeys } = this.state;

        const columns = [
            {
                title: languageMessages['strategy id'],
                dataIndex: 'sequence',
                align: 'center',
                width: 60
            },
            /**
            {
                title: languageMessages['grandTotalRateOfReturn'] + '(%)',
                dataIndex: 'grandTotalRateOfReturn',
                width: 140,
                align: 'center',
                sorter: (a, b) => a.grandTotalRateOfReturn - b.grandTotalRateOfReturn,
                sortDirections: ['descend', 'ascend'],
                render: (text, row, index) => {
                    if (row['grandTotalRateOfReturn'] >= 0) {
                        return <span style={{ color: window.webType === 'US' ? 'green' : 'red' }}>{text}</span>;
                    } else {
                        return <span style={{ color: window.webType === 'US' ? 'red' : 'green' }}>{text}</span>;
                    }
                }
            }, {
                title: languageMessages['annualizedRateOfReturn'] + '(%)',
                dataIndex: 'annualizedRateOfReturn',
                width: 125,
                align: 'center',
                sorter: (a, b) => a.annualizedRateOfReturn - b.annualizedRateOfReturn,
                sortDirections: ['descend', 'ascend'],
                render: (text, row, index) => {
                    if (row['annualizedRateOfReturn'] >= 0) {
                        return <span style={{ color: window.webType === 'US' ? 'green' : 'red' }}>{text}</span>;
                    } else {
                        return <span style={{ color: window.webType === 'US' ? 'red' : 'green' }}>{text}</span>;
                    }
                }
            },*/
            {
                title: languageMessages['tbLogin'],
                dataIndex: 'tbLogin',
                width: 100,
                align: 'center',
                sorter: (a, b) => a.tbLogin - b.tbLogin,
                sortDirections: ['descend', 'ascend']
            }, {
                title: languageMessages['minimumCapital'],
                dataIndex: 'capital',
                width: 155,
                align: 'center',
                sorter: (a, b) => a.capital - b.capital,
                sortDirections: ['descend', 'ascend'],
            }, {
                title: languageMessages['category'],
                dataIndex: 'category',
                width: 200,
                render: category => {
                    return strCategory[category]
                }
            }, {
                title: languageMessages['dayTradeOnly'],
                dataIndex: 'dayTradeOnly',
                width: 90,
                render: dayTradeOnly => {
                    return dayTradeOnly === 0 ? languageMessages['crossDay'] : languageMessages['intraday']
                }
            }, {
                title: languageMessages['startTime'],
                dataIndex: 'startTime',
                width: 160,
                //sorter: (a, b) => a.created - b.created,
                //sortDirections: ['descend', 'ascend']
            },
            {
                title: languageMessages['endTime'],
                dataIndex: 'endTime',
                width: 160,
                //sorter: (a, b) => a.created - b.created,
                //sortDirections: ['descend', 'ascend']
            },
            {
                title: languageMessages['status'],
                dataIndex: 'status',
                width: 80,
                sorter: (a, b) => a.status - b.status,
                sortDirections: ['descend', 'ascend'],
                render: status => (
                    <span>
                        {status == 0 ? languageMessages['stopped'] : status == 1 ? languageMessages['running'] : status == 4 ? languageMessages['waiting'] : languageMessages['over']}
                    </span>
                )
            }, 
            {
                title: languageMessages['control'],
                dataIndex: 'operation',
                //fixed: 'right',
                width: 100,
                render: (text, record) => {
                    return <Button size='small' onClick={() => this.handleStrategy(record)}>{languageMessages['goRealTime']}</Button>
                }
            }
        ];

        if (symbolCode.search(languageMessages['no.matches.found']) !== -1) {
            symbolCode = symbolCode.replace(languageMessages['no.matches.found'], '');
            symbolCode = symbolCode.substring(1, symbolCode.length - 1);
        }

        const rowSelection = {
            title: languageMessages['select.all'],
            selectedRowKeys: selectedRowKeys,
            onChange: this.onSelectChange
        }

        return (<Content className='main-container total-content'>
            <Helmet>
                <title>{languageMessages['title']}</title>
                <meta name="keywords" content={languageMessages['keywords']} />
                <meta name="description" content={languageMessages['description']} />

                <meta property="og:title" content={languageMessages['title']} />
                <meta property="og:url" content="https://us.quancept.com/" />
                <meta property="og:type" content="website" />
                <meta name="og:description" content={languageMessages['description']} />

                <meta property="twitter:url" content="https://us.quancept.com/" />
                <meta name="twitter:title" content={languageMessages['title']} />
                <meta name="twitter:description" content={languageMessages['description']} />
                <meta name="twitter:site" content="https://us.quancept.com/" />
            </Helmet>
            <Spin spinning={this.state.spinLoadding}>
                <div className='common-page-header'>
                    <PageHeader title={(<h1>{languageMessages['mySimulated'] + ' » ' + languageMessages['stockStrategy']}</h1>)} />
                </div>
                <div style={{ padding: '0px 50px' }}>
                    <div className='common-title'><Divider type="vertical" />{languageMessages['backtestFilter']}</div>
                    <div style={{ padding: '10px 0' }}>
                        <div className='common-panel'>
                            <label className='common-label-cn'>{languageMessages['symbolCode']}</label>
                            <AutoComplete value={symbolCode}
                                className="certain-category-search"
                                dropdownClassName="certain-category-search-dropdown"
                                dropdownMatchSelectWidth={false}
                                dropdownStyle={{ width: 200 }}
                                size="small"
                                style={{ width: '200px' }}
                                dataSource={symbolItems.map(group => (
                                    <Option key={group.symbol} value={group.symbol}>
                                        {group.symbol}
                                        <span className="certain-search-item-count">{group.symbolName}</span>
                                    </Option>
                                ))}
                                onChange={this.onChangeSymbol}
                                onSearch={this.handleSearch}
                                onSelect={this.onSelectSymbol}
                                onFocus={this.onFocusSymbol}
                                onBlur={this.onBlurSymbol}
                                placeholder={languageMessages['pleaseEnterSymbolCode']}
                                optionLabelProp="value">
                                <Input suffix={<Icon type="search" className="certain-category-icon" />} />
                            </AutoComplete>
                        </div>
                        <div className='common-panel' style={{ display: 'none' }}>
                            <label className='common-label-cn'>{languageMessages['annualizedRateOfReturn']}</label>
                            <Select labelInValue size='small' value={{ key: this.state.maxRateOfReturn }} style={{ width: '120px' }} onChange={this.handleIncomesChange}>
                                {
                                    selRateOfReturn.map(item => (
                                        <Option key={item.id}>{item.name}</Option>
                                    ))
                                }
                            </Select>
                        </div>
                        <div style={{ float: 'right' }}>
                            <Button onClick={this.handleSearchStockTrade}>{languageMessages['search']}</Button>
                            <Button style={{ marginLeft: '10px' }} onClick={this.clearFilter}>{languageMessages['clearFilter']}</Button>
                        </div>
                    </div>

                    <Layout className='backtest-content'>
                        <Sider width={280}>
                            <div className='common-sider-header'>{languageMessages['symbolName&Code']}</div>
                            <Divider />
                            {this.renderStockTrade(strategyData)}
                        </Sider>
                        <div className='common-content'>
                            <div className='common-tools'>
                                <Button onClick={this.onRemove} disabled={selectedRowKeys.length > 0 ? false : true}>{languageMessages['Undeploy']}</Button>
                            </div>
                            <Table size='middle' locale={{ emptyText: ' ' }}
                                columns={columns}
                                dataSource={dataSource}
                                rowSelection={rowSelection}
                                onRow={this.OnSelectShowChart}
                                rowClassName={this.setRowClassName}
                                pagination={false} scroll={{ y: 331 }} />
                        </div>
                    </Layout>
                </div>
                <Content style={{ padding: '0px 50px', marginBottom: '50px' }}>
                    {this.state.statisticsResult.length == 0 || (<TradeResult dispatch={this.props.dispatch} statisticsResult={this.state.statisticsResult} type={this.state.type} />)}
                </Content>
            </Spin>
            <Modal
                title={this.state.modalTitle}
                visible={this.state.modalVisible}
                maskClosable={false}
                onOk={this.handleOk}
                confirmLoading={this.state.spinModalLoadding}
                onCancel={this.handleCancel}>
                {this.renderModalContent()}
            </Modal>
        </Content>);
    }
}

function mapStateToProps(state) {
    return state.trade;
}

const page = connect(mapStateToProps)(SimulationPage);
export { page as default }